import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import { batch as reduxBatch } from 'react-redux';
import IRecommendationsConfigActionsService from 'services/storageModelActions/recommentationsConfig/IRecommendationsConfigActionsService';
import {
  RecommendationConfigRequestDTO,
  RecommendationConfigResponseDTO,
  RecommendationResultDTO,
  UpdateRecommendationConfigResponseDTO,
} from 'typings/dto/recommendationsConfig';
import { PATH_BACKEND, PATH_BACKEND_PART } from 'configs/routes/pathsBackend';

export default class RecommendationsConfigActionsServiceImpl
  extends ModelActionsService<RecommendationsConfig, RecommendationConfigRequestDTO, RecommendationConfigResponseDTO>
  implements IRecommendationsConfigActionsService
{
  public async getRecommendationsForSession(orderSession: string): Promise<RecommendationResultDTO> {
    let url = `${PATH_BACKEND.recommendationsConfig.session}/${orderSession}`;

    return this.entityApiService.getWithCredentials<RecommendationResultDTO>(url);
  }

  public async getRecommendationsConfig(): Promise<void> {
    this.storageDispatch(this.modelStorageActions.startLoading());
    await reduxBatch(async () => {
      try {
        const controller = new AbortController();
        this.oneRequestController = controller;
        const response = await this.entityApiService
          .getWithCredentials<RecommendationConfigResponseDTO>(this.getModelApiRootPath(), { signal: controller.signal })
          .then(this.modelMapper.responseDTOToModel);
        this.oneRequestController = null;
        this.storageDispatch(this.modelStorageActions.setOne(response));
        this.storageDispatch(this.modelStorageActions.stopLoading());
      } catch (error) {
        if (error instanceof Error && error.name === 'AbortError') {
          console.warn(`Get by id background request ${this.modelStorageName} is outdated`);
        } else {
          console.error(error);
          this.storageDispatch(this.modelStorageActions.setError(error));
        }
      }
    });
  }

  public async updateRecommendationsConfig(dto: RecommendationsConfig): Promise<UpdateRecommendationConfigResponseDTO> {
    const response = await this.entityApiService.putWithResponse<UpdateRecommendationConfigResponseDTO>(
      this.getModelApiRootPath(dto),
      dto
    );
    this.storageDispatch(this.modelStorageActions.setOneIsOutdated());
    return response;
  }

  /** @throws `BackendResponseError` */
  public exportConfig = async (): Promise<void> => {
    const path = `${PATH_BACKEND.recommendationsConfig.root}/${PATH_BACKEND_PART.recommendationsConfig.export}`;
    await this.entityApiService.postWithCredentials(path);
  };

  /** Используется multipart/form-data */
  public importConfig = (file: File, force: string): Promise<void> => {
    const path = `${PATH_BACKEND.recommendationsConfig.root}/${PATH_BACKEND_PART.recommendationsConfig.import}`;
    const formData = new FormData();
    formData.append('file', file);
    formData.set('force', force);
    return this.entityApiService.postMultipart(path, formData);
  };
}
